export const brandTextStyle = {
  color: 'var(--color-text-primary)'
};
